import React, { useEffect, useState } from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {State} from '../../../../reducers'
import {bindActionCreators} from 'redux'
import {actionFacturacionCliente, actionGeneral, actionSujetoExcluidoCliente, actionSujetoExcluidoProducto, actionsClienteReceptor} from '../../../../actions/action-creators'
import {isNullOrEmpty} from '../../../../utils/strings.utils'
import InputPhone from '../../../../components/Inputs/InputPhone'
import SearchSelect from '../../../../components/Inputs/SearchSelect'
import ModalInfoCliente from '../../../EmitirFactura/Components/GeneracionFactura/Modals/ModalInfoCliente'
import { sujetoExcluidoInitialState2 } from '../../../../initital-state/sujetoExcluido.state'
import ModalConfirm from '../../../../components/Modals/Generales/ModalConfirm'
import InputChips from '../../../OtrosDocumentos/Components/InputChips'

const SEDatosCliente = () => {
  const {fecha_actual} = useSelector((state: State) => state.general)
  const formCliente = useSelector((state: State) => state.sujetoExcluido.formCliente)
  const errors = useSelector((state: State) => state.sujetoExcluido.errorsFormCliente)
  const {tipoDocumento, departamentos, municipios, condicionOperacion} = useSelector((state: State) => state.catalogos)
  const loader = useSelector((state: State) => state.general.loader)
  const modalInfo = useSelector((state: State) => state.facturacion.modals.activeInfoCliente)
  const [modalServicios, setModalServicios] = useState(false);
  const dispatch = useDispatch()
  const acciones = bindActionCreators(actionSujetoExcluidoCliente, dispatch)
  const accionesProductos = bindActionCreators(actionSujetoExcluidoProducto, dispatch)
  const accionesClienteReceptor = bindActionCreators(actionsClienteReceptor, dispatch)
  const accionesFacturacion = bindActionCreators(actionFacturacionCliente, dispatch)
  const {getFechaHora} = bindActionCreators(actionGeneral, dispatch)

  useEffect(() => {
    getFechaHora()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])  

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | any) => {
    acciones.sujetoExcluidoFormClienteHandleChangeInput(e)
    acciones.sujetoExcluidoFormClienteOnBlur(e)
  }
  
  const onBlurClient = async (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>)  => {
    acciones.sujetoExcluidoFormClienteOnBlur(e)
    if(formCliente.tipoDocumento && formCliente.numId) {
      const user = await accionesClienteReceptor.buscarClienteReceptor(formCliente)
      if(user !== null) {
        dispatch(accionesFacturacion.facturacionInfoCliente(user))
        dispatch(accionesFacturacion.facturacionOpenModalCliente())
      }
    }
  }
  
  const confirmarDatos = (data:any) => {
    dispatch(acciones.sujetoExcluidoFormClienteHandleChange({...data, chipsEmail: data?.email ? data.email.split(',').filter((e: string) => e.trim()) : [], email: ''}));
    dispatch(acciones.sujetoExcluidoFormClienteAddError(sujetoExcluidoInitialState2.errorsFormCliente))
  }
  
  const handleTipoDocumento = async (value: any) => {
    if( value?.value === "37") {
      if(await accionesProductos.sujetoExcluidoProductosVerificacionServicios()) return setModalServicios(true)
    }
    acciones.sujetoExcluidoFormClienteHandleChangeInput({target: {value: value?.value, name: 'tipoDocumento'},})
  }
  
  const confirmarEliminacionServiciosDoc = () => {
    dispatch(accionesProductos.sujetoExcluidoDeleteServicios())
    acciones.sujetoExcluidoFormClienteHandleChangeInput({target: {value: "37", name: 'tipoDocumento'},})
    setModalServicios(false)
  }

  return (
    <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ec6-0b1e6fa6' className='w-layout-cell'>
      {modalInfo && <ModalInfoCliente confirmarDatos={(datos:any) => confirmarDatos(datos)} noNRC={true} noActividad={true}/>}
      {modalServicios && <ModalConfirm Styles={{maxWidth: "500px"}} title={'Eliminación de Servicios'}
          detail={`Para cambiar el tipo de documento a la opción "Otro", el cual NO permite tener servicios incluidos, se procederá a la eliminación de los servicios agregados, ¿Estás seguro que deseas cambiar a el tipo de documento a "Otro"?`} messageAction='Sí' messageClose='No'
          actionConfirm={() =>  confirmarEliminacionServiciosDoc()}
          closeModalConfirm={() => setModalServicios(false)}
        />}
      <div className='card w-form'>
        <form className='form-content' data-wf-page-id='64b58c72be2b65200b1e6fa6' data-wf-element-id='deb0f47f-468f-13fc-f1eb-4d36c39616dc' autoComplete='off'>
          <div><h3 className='card-title l'>Datos del Cliente</h3></div>
          <div className='form-separator'></div>
          <div className='w-layout-hflex h-inputs'>
            <div className='label-input'>
              <label htmlFor='fecha' className='field-label m'>Fecha de factura</label>
              <input autoComplete='off' type='date' className='m text-field w-input' name='fecha' data-name='' id='fecha' min='2000-01-01'
                value={fecha_actual?.FechaInput || formCliente.fecha} disabled={true} onChange={handleChange} onBlur={acciones.sujetoExcluidoFormClienteOnBlur}/>
              {errors.fecha && <p className='alert s'>{errors.fecha}</p>}
            </div>
            <div className='label-input'>
              <label htmlFor='tipoDocumento' className='field-label m'>Tipo de documento<span style={{color: 'red'}}>*</span></label>
              <SearchSelect
                defaultValue={null}
                data={tipoDocumento}
                value={formCliente.tipoDocumento}
                disabled={false}
                keyNameText='valor'
                keyNameValue='codigo'
                placeholder='Tipo de documento'
                name='tipoDocumento'
                onChange={(value: any) => {handleTipoDocumento(value)}}
              />
              {errors.tipoDocumento && <p className='alert s'>{errors.tipoDocumento}</p>}
            </div>
          </div>
          <div className='w-layout-hflex h-inputs'>
            <div className='label-input'>
              <label htmlFor='numId' className='field-label m'>{formCliente.nombreTipoDocumento || 'Número de identificación'}<span style={{color: 'red'}}>*</span></label>
              <input
                autoComplete='off'
                type='text'
                className='m text-field w-input'
                name='numId'
                data-name='numId'
                placeholder={`Número de ${formCliente.nombreTipoDocumento || 'Identificación'}`}
                id='numId'
                disabled={formCliente.tipoDocumento ? false : true}
                maxLength={20}
                value={formCliente.numId}
                onChange={handleChange}
                onBlur={onBlurClient}
              />
              {errors.numId && <p className='alert s'>{errors.numId}</p>}
            </div>
            <div className='label-input'></div>
          </div>
          <div className='w-layout-hflex h-inputs'>
            <div className='label-input'>
              <label htmlFor='nombre' className='field-label m'>Nombre del cliente<span style={{color: 'red'}}>*</span></label>
              <input
                autoComplete='off'
                type='text'
                className='m text-field w-input'
                name='nombre'
                data-name=''
                placeholder='Nombre del cliente'
                id='nombre'
                disabled={formCliente.tipoDocumento ? false : true}
                maxLength={250}
                value={formCliente.nombre}
                onChange={handleChange}
                onBlur={acciones.sujetoExcluidoFormClienteOnBlur}
              />
              {errors.nombre && <p className='alert s'>{errors.nombre}</p>}
            </div>
            <div className='label-input'>
              <label htmlFor='departamento' className='field-label m'>Departamento<span style={{color: 'red'}}>*</span></label>
              <SearchSelect
                defaultValue={null}
                data={departamentos?.map((dep) => ({...dep, codigo_nombre: `${dep.codigo} - ${dep.valor}`}))}
                value={formCliente.departamento}
                keyNameText='codigo_nombre'
                keyNameValue='codigo'
                placeholder='Departamento'
                disabled={loader ? true : formCliente.tipoDocumento ? false : true}
                name='departamento'
                onChange={(value: any) => {handleChange({target: {value: value?.value, name: 'departamento'},})}}
              />
              {errors.departamento && <p className='alert s'>{errors.departamento}</p>}
            </div>
          </div>
          <div className='w-layout-hflex h-inputs'>
            <div className='label-input'>
              <label htmlFor='municipio' className='field-label m'>Municipio<span style={{color: 'red'}}>*</span></label>
              <SearchSelect
                defaultValue={null}
                data={municipios?.map((mun) => ({...mun, codigo_nombre: `${mun?.codigo} - ${mun?.valor}`}))}
                value={formCliente.municipio}
                keyNameText='codigo_nombre'
                keyNameValue='codigo'
                placeholder='Municipio'
                disabled={isNullOrEmpty(formCliente.departamento) ? true : formCliente.tipoDocumento ? false : true}
                name='municipio'
                onChange={(value: any) => {handleChange({target: {value: value?.value, name: 'municipio'},})}}
              />
              {errors.municipio && <p className='alert s'>{errors.municipio}</p>}
            </div>
            <div className='label-input'>
              <label htmlFor='direccion' className='field-label m'>Dirección<span style={{color: 'red'}}>*</span></label>
              <input
                autoComplete='off'
                type='text'
                className='m text-field w-input'
                name='direccion'
                data-name=''
                placeholder='Dirección'
                id='direccion' 
                disabled={isNullOrEmpty(formCliente.municipio) ? true : formCliente.tipoDocumento ? false : true }
                maxLength={200}
                value={formCliente.direccion}
                onChange={handleChange}
                onBlur={acciones.sujetoExcluidoFormClienteOnBlur}
              />
              {errors.direccion && <p className='alert s'>{errors.direccion}</p>}
            </div>
          </div>
          <div className='w-layout-hflex h-inputs'>
            <InputChips 
              maxChips={5} chips={formCliente.chipsEmail} setChips={(chipsEmail: Array<string>) => acciones.sujetoExcluidoFormClienteHandleChangeInput({target: {value: chipsEmail, name: 'chipsEmail'}})} 
              maxLength={100} onBlur={acciones.sujetoExcluidoFormClienteOnBlur} required name='email' placeholder='Correo electrónico' 
              label = 'Correo electrónico' type='email' value={formCliente.email} error={errors.email} onChange={handleChange}
              disabled={formCliente.tipoDocumento ? false : true}
            />
          </div>
          <div className='w-layout-hflex h-inputs'>
            <div className='label-input'>
              <label htmlFor='telefono' className='field-label m'>
                Teléfono celular<span style={{color: 'red'}}>*</span>
              </label>
              <InputPhone
                className='m text-field w-input'
                name='telefono'
                disabled={formCliente.tipoDocumento ? false : true}
                value={formCliente.telefono}
                onChange={acciones.sujetoExcluidoFormClienteHandleChangeInputPhone}
                onBlur={acciones.sujetoExcluidoFormClienteOnBlur}
              />
              {errors.telefono && <p className='alert s'>{errors.telefono}</p>}
            </div>
            <div className='label-input'>
            </div>
          </div>
          <div className='form-separator'></div>
          <div style={{display:"none"}}>            
            <div><h3 className='card-title l'>Condición de la operación</h3></div>
            <div className='form-separator'></div>
            <div className='label-input'>
              <label htmlFor='condicion' className='field-label m'>Forma de pago<span style={{color: 'red'}}>*</span></label>
              <SearchSelect
                defaultValue={null}
                data={condicionOperacion}
                value={formCliente.condicion}
                keyNameText='valor'
                keyNameValue='codigo'
                placeholder='Condición de la operación'
                disabled={false}
                name='condicion'
                onChange={(value: any) => {handleChange({target: {value: value?.value, name: 'condicion'},})}}
              />
              {errors.condicion && <p className='alert s'>{errors.condicion}</p>}
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

export default SEDatosCliente
